import { Basemap } from '@workspaces/types'

export function isGoogleMapsBasemap(option: Basemap.Basemap): boolean {
  return option.startsWith('GoogleMaps')
}
